export default __webpack_public_path__ + "static/breadcrumbs-parts-dark-0ec133db99274c9dd85b82caf2da046f.png";